import api from "../../api";

class BackendCategoryAPI {
    static all() {
        return api.get("/backend/categories/all");
    }

    static create(payload) {
        return api.post(`/backend/categories`, payload);
    }

    static update(id, payload = {}) {
        return api.patch(`/backend/categories/${id}`, payload);
    }

    static delete(id) {
        return api.delete(`/backend/categories/${id}`);
    }

    static list(payload) {
        const params = {
            page: payload?.page,
            take: payload?.take,
        };

        Object.keys(payload.filter ?? {}).forEach((k) => {
            params[`filter[${k}]`] = payload.filter[k] ? payload.filter[k] : undefined;
        });

        return api.get("/backend/categories", { params });
    }
}

export default BackendCategoryAPI;
